import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';

import { useTranslation } from '../../../helpers/hooks/useTranslation';
import AppErrorBoundary from '../../AppErrorBoundary';
import './MonthViewCalendars.scss';

import MonthCalendar from './MonthCalendar';

const cls = cssModules({});

type MonthViewCalendarsProps = {
  isReturn: boolean;
};

const MonthViewCalendars = ({ isReturn }: MonthViewCalendarsProps) => {
  const translate = useTranslation();
  const outboundLabel = translate('outbound_month_label');
  const inboundLabel = translate('inbound_month_label');

  return (
    <div
      className={cls('clearfix', 'month-view__calendar-area')}
      data-percy-id="calendar-area"
    >
      {isReturn && (
        <div>
          <section
            aria-label={outboundLabel}
            className={cls('month-view-calendar', 'outbound-calendar')}
            data-testid="month-view-outbound-calendar"
          >
            <AppErrorBoundary location="month-view-calendar outbound-calendar">
              <MonthCalendar direction="outbound" />
            </AppErrorBoundary>
          </section>
          <section
            aria-label={inboundLabel}
            className={cls('month-view-calendar', 'inbound-calendar')}
            data-testid="month-view-inbound-calendar"
          >
            <AppErrorBoundary location="month-view-calendar inbound-calendar">
              <MonthCalendar direction="inbound" />
            </AppErrorBoundary>
          </section>
        </div>
      )}
      {!isReturn && (
        <div
          className="month-view-calendar one-way-calendar"
          data-testid="month-view-one-way-calendar"
        >
          <AppErrorBoundary location="month-view-calendar one-way-calendar">
            <MonthCalendar direction="outbound" />
          </AppErrorBoundary>
        </div>
      )}
    </div>
  );
};

export default MonthViewCalendars;
